module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lynx/lyn_gal-a6db8ca1e172ce32ba8cfeffd834ddc3.gif";